//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 협력업체 평가 - 협력업체 평가서 (SUB_BASIC_03) 전용 로직
 * other 케이스에서 사용
 */

// 회의사진 가져오기 함수
const SearchPhoto = async (_filePath, imgRef) => {
  imgRef.current = null;

  try {
    imgRef.current = Global.file.useUrl + 'files/' + _filePath;
  } catch (e) {
    console.log(e);
  } finally {
  }
};

// 서명 파일 변환 함수
function SignFileConvert(_filePath) {
  if (!_filePath) return null;

  const signUrl = `${Global.file.useUrl}files/${_filePath}`;
  let testSign = `data:image/png;base64,${signUrl}`;
  let sign1 = testSign.replace(
    /^data:image\/[a-z]+;base64,/, // 단위작업사진(접두사 없어야 됨)
    ''
  );

  return sign1 || '';
}

// SUB_BASIC_03 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터
  dispatch,
  setLoading,
  searchRef,
  imgRef
) => {
  if (!documentData) {
    dispatch(
      showSnackbar({
        message: '항목을 선택하세요.',
        type: 'warning',
      })
    );
    return null;
  }

  setLoading(true);
  try {
    const selectedMeeting = documentData;
    const chaebun =
      selectedMeeting.CHAEBUN || selectedMeeting.chaebun || '';

    if (!chaebun) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터를 불러올 수 없습니다.',
          type: 'error',
        })
      );
      return null;
    }

    // 사업장명(custNm)
    const custNm =
      searchRef?.current?.custList?.find(
        (item) => item.value === searchRef?.current?.custCd
      )?.custNm || '';

    // 날짜/시간 포맷
    const proceedingsDateRaw =
      selectedMeeting.PROCEEDINGS_DATE ||
      selectedMeeting.proceedingsDate ||
      '';
    const proceedingsDate = proceedingsDateRaw
      ? dayjs(proceedingsDateRaw).format('YYYY-MM-DD')
      : '';
    const startTimeRaw =
      selectedMeeting.PROCEEDINGS_START_TIME ||
      selectedMeeting.proceedingsStartTime ||
      '';
    const endTimeRaw =
      selectedMeeting.PROCEEDINGS_END_TIME ||
      selectedMeeting.proceedingsEndTime ||
      '';

    const safeTime = (v) => {
      if (!v) return '';
      if (typeof v === 'string' && /^\d{2}:\d{2}$/.test(v)) return v;
      const parsed = dayjs(v);
      return parsed.isValid() ? parsed.format('HH:mm') : '';
    };

    const startTime = safeTime(startTimeRaw);
    const endTime = safeTime(endTimeRaw);
    const proceedingsDateTime = `${proceedingsDate}${startTime ? ` ${startTime}${endTime ? ` ~ ${endTime}` : ''}` : ''
      }`;

    // 회의사진 영역 리셋 및 조회 (실패해도 계속 진행)
    if (imgRef) {
      imgRef.current = null;
    }
    const proceedingsImage =
      selectedMeeting.PROCEEDINGS_IMAGE ||
      selectedMeeting.proceedingsImage ||
      '';
    const proceedingsImageNm =
      selectedMeeting.PROCEEDINGS_IMAGE_NM ||
      selectedMeeting.proceedingsImageNm ||
      '';
    if (proceedingsImage && imgRef) {
      try {
        await SearchPhoto(proceedingsImage, imgRef);
      } catch (e) {
        // 사진 조회 실패해도 인쇄는 계속 진행
      }
    }

    // 1) headerData (PrintLogic3 구조)
    const headerData = [
      {
        proceedingsTitle:
          selectedMeeting.PROCEEDINGS_TITLE ||
          selectedMeeting.proceedingsTitle ||
          '',
        proceedingsDateTime,
        proceedingsLocation:
          selectedMeeting.PROCEEDINGS_LOCATION ||
          selectedMeeting.proceedingsLocation ||
          '',
        state: selectedMeeting.STATE || selectedMeeting.state || '',
        custNm,
        month: dayjs().format('MM'),
        proceedingsImage,
        proceedingsImageNm,
        meetingPhoto: imgRef?.current
          ? String(imgRef.current).replace(/^data:image\/[a-z]+;base64,/, '')
          : imgRef?.current || '',
        meetingHost: selectedMeeting.meetingHost || '',
        meetingCycle: selectedMeeting.meetingCycle || '',
      },
    ];

    // 2) 참석자/수급업체 참석자: GetSubBasicMst03R3에서 gubun 포함 행만 추출
    const result1 = await apiRequest(
      'post',
      Global.urls.DocsManagement.getSubBasicMst03R3,
      {
        Chaebun: Commons.EncryptAES(chaebun) || '',
      }
    );

    const detailRowsRaw = result1?.data;
    const detailRows = Array.isArray(detailRowsRaw)
      ? detailRowsRaw
      : detailRowsRaw
        ? [detailRowsRaw]
        : [];

    if (!detailRows.length || detailRows[0]?.type === 'Error') {
      dispatch(
        showSnackbar({
          message: detailRows[0]?.message || '인쇄할 데이터가 없습니다.',
          type: 'error',
        })
      );
      return null;
    }

    const attendeeRows = detailRows.filter(
      (r) => r?.gubun || r?.GUBUN || r?.Gubun
    );
    const list0 = attendeeRows.filter(
      (r) => String(r?.gubun ?? r?.GUBUN ?? r?.Gubun ?? '') === '0'
    );
    const list1 = attendeeRows.filter(
      (r) => String(r?.gubun ?? r?.GUBUN ?? r?.Gubun ?? '') === '1'
    );

    const maxLength = Math.max(list0.length, list1.length, 7);
    const tableData1 = [];
    for (let i = 0; i < maxLength; i++) {
      const r0 = list0[i] || {};
      const r1 = list1[i] || {};
      tableData1.push({
        depNm1: r0.DEP_NM || r0.depNm || '',
        name1: r0.NAME || r0.name || '',
        signature1: SignFileConvert(r0.FILE_PATH || r0.filePath) || '',
        depNm2: r1.CUST_NM || r1.custNm || '',
        name2: r1.NAME || r1.name || '',
        signature2: SignFileConvert(r1.FILE_PATH || r1.filePath) || '',
      });
    }
    const tableData2 = [];

    // 3) 회의안건: GetSubBasicMst03R2
    const result2 = await apiRequest(
      'post',
      Global.urls.DocsManagement.getSubBasicMst03R2,
      {
        Chaebun: Commons.EncryptAES(chaebun) || '',
      }
    );

    const agendaRowsRaw = result2?.data;
    const agendaRows = Array.isArray(agendaRowsRaw)
      ? agendaRowsRaw
      : agendaRowsRaw
        ? [agendaRowsRaw]
        : [];

    if (agendaRows[0]?.type === 'Error') {
      dispatch(
        showSnackbar({
          message: agendaRows[0]?.message || '인쇄할 데이터가 없습니다.',
          type: 'error',
        })
      );
      return null;
    }

    const tableData3 = agendaRows
      .filter(
        (item) =>
          item?.AGENDA_NAME ||
          item?.agendaName ||
          item?.RESULT_DISCUSSION ||
          item?.resultDiscussion
      )
      .slice(0, 9)
      .map((item, index) => ({
        no: index + 1,
        agendaName: item.AGENDA_NAME || item.agendaName || '',
        resultDiscussion:
          item.RESULT_DISCUSSION || item.resultDiscussion || '',
      }));

    const printData = {
      FileName: 'SUB_BASIC_03',
      HeaderData: JSON.stringify(headerData),
      TableData1: JSON.stringify(tableData1),
      TableData2: JSON.stringify(tableData2),
      TableData3: JSON.stringify(
        tableData3.length
          ? tableData3
          : [{ no: '', agendaName: '', resultDiscussion: '' }]
      ),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    }
    console.error('PrintLogic1: 응답 데이터가 없습니다.');
    return null;
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e?.message || '인쇄 중 오류가 발생했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
